import React, { useState} from "react";
import create_poll_symbol from './create_poll_symbol.png';
import './createpollcard.css';
import { Modal } from "antd";
import CreatePoll from '../createPoll/CreatePoll'

interface Props {
    requestUrl: string;
    refreshRequestBody: any
}

const CreatePollCard: React.FC<Props> = ({ requestUrl, refreshRequestBody }) => {
    const [visible, setVisible] = useState(false);

    const showModal = () => {
        setVisible(true);
    };
    
    const handleCancel = () => {
        setVisible(false);
    };

    return(
        <div className='create_poll_card'>
            <div className='create_card_content' onClick={showModal}>
                    <img alt='poll_symbol' className='poll_symbol'  src={create_poll_symbol}/>
                    <p className='create_poll'>Create Poll</p>
            </div>
            <Modal title="Create a Poll" visible={visible} onCancel={handleCancel} footer={null}>
                <CreatePoll refreshRequestBody={refreshRequestBody} handleCancel={handleCancel} requestUrl={requestUrl} />
            </Modal>
        </div>   
    )
};

export default CreatePollCard;